export const routes = {
  eventsCalendar: "/event-calendar",

  // Default events redirect updated to Book Now path
  events: "/booknow/Residential%20Study%20Courses/1",

  moreEvents: "/booknow/Residential%20Study%20Courses/1",
  moreProducts: "/products",
};
